import styled from 'styled-components';

export const Container = styled.div`
    -webkit-tap-highlight-color: transparent;
    display: flex;
    flex-direction: row;
    align-items: space-around;
    padding: 20px;

    .extensionCard {
        min-width: 230px;
    }

    @media (max-width: 782px) {
        .extensionCard {
            display: none;
        }
    }
`;

export const CompanyDescription = styled.span`
    font-size: 18px;
    max-width: 60%;
    padding-top: 20px;
    padding-bottom: 20px;

    @media (max-width: 515px) {
        font-size: 16px;
    }

    @media (max-width: 782px) {
        max-width: 100%;
        width: 100%;
    }
`
